import { Icon, IconProps } from "@chakra-ui/react";

export function MenuHintThinIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M16.5 4C16.5 3.72386 16.2761 3.5 16 3.5H8C7.72386 3.5 7.5 3.72386 7.5 4V20C7.5 20.2761 7.72386 20.5 8 20.5H16C16.2761 20.5 16.5 20.2761 16.5 20V4ZM17.5 20C17.5 20.8284 16.8284 21.5 16 21.5H8C7.17157 21.5 6.5 20.8284 6.5 20V4C6.5 3.17157 7.17157 2.5 8 2.5H16C16.8284 2.5 17.5 3.17157 17.5 4V20Z"
        fill="currentColor"
      />
      <circle cx="14.5" cy="14.5" r="0.5" fill="currentColor" />
      <circle cx="14.5" cy="12.5" r="0.5" fill="currentColor" />
      <circle cx="14.5" cy="16.5" r="0.5" fill="currentColor" />
      <rect x="9" y="18" width="6" height="1" rx="0.5" fill="currentColor" />
      <rect x="9" y="5" width="3" height="1" rx="0.5" fill="currentColor" />
      <rect x="9" y="7" width="3" height="1" rx="0.5" fill="currentColor" />
      <rect x="9" y="9" width="2" height="1" rx="0.5" fill="currentColor" />
      <rect
        x="15"
        y="5"
        width="2"
        height="1"
        rx="0.5"
        transform="rotate(90 15 5)"
        fill="currentColor"
      />
    </Icon>
  );
}
